module.exports = __webpack_public_path__ + "img/withbd.f4b1515b.gif";